import type { ChainLayer, ExplicitAddress } from '@cronos-app/sdk';
import type { IntlInternalUrl } from '@ts-intl/integration';

import { INTERNAL_LAYER_TO_USER } from './layer';

type IntlInternalUrlObject = Exclude<IntlInternalUrl, string>;

export const paths = {
  home: '/',
  agents(agentId?: number | string) {
    return '/' + (agentId || agentId === 0 ? `#${agentId}` : '');
  },
  agent(id: ExplicitAddress, chainLayer?: ChainLayer): IntlInternalUrlObject {
    return {
      pathname: '/agent',
      query: {
        id,
        chain: chainLayer ? INTERNAL_LAYER_TO_USER[chainLayer] : undefined,
      },
    };
  },
  create: '/create',
  profile(userAddress: string) {
    return `/profile?id=${userAddress}`;
  },
} as const;
